import PopularCategories from './PopularCategories.component';

export default PopularCategories;